import type { Namespace } from '../types';

// DE drafted — queued for native review in the task file's "DE review queue".
export const auditLog = {
  title: { de: 'Audit-Protokoll', en: 'Audit Log' },
  desc: {
    de: 'Unveränderliches Protokoll aller sicherheitsrelevanten Aktionen — Zeile anklicken für Details',
    en: 'Immutable record of every security-relevant action — click a row for details',
  },

  filterAction: { de: 'Aktion (Präfix, z. B. auth.)', en: 'Action (prefix, e.g. auth.)' },
  search: { de: 'Aktion oder E-Mail suchen', en: 'Search action or email' },
  modeText: { de: 'Aktion', en: 'Action' },
  modeUser: { de: 'Benutzer', en: 'User' },
  filterUser: { de: 'Benutzer suchen…', en: 'Search a user…' },
  searching: { de: 'Suche…', en: 'Searching…' },
  noUsers: { de: 'Keine Benutzer gefunden', en: 'No users found' },
  clear: { de: 'Filter entfernen', en: 'Clear filter' },
  resAll: { de: 'Alle', en: 'All' },
  resSuccess: { de: 'Erfolg', en: 'Success' },
  resDenied: { de: 'Verweigert', en: 'Denied' },
  resError: { de: 'Fehler', en: 'Error' },

  colTime: { de: 'Zeit', en: 'Time' },
  colActor: { de: 'Akteur', en: 'Actor' },
  colAction: { de: 'Aktion', en: 'Action' },
  colResource: { de: 'Ressource', en: 'Resource' },
  colResult: { de: 'Ergebnis', en: 'Result' },
  colIp: { de: 'IP', en: 'IP' },
  colSite: { de: 'Standort', en: 'Site' },

  filterSite: { de: 'Alle Standorte', en: 'All sites' },
  fromLabel: { de: 'Von', en: 'From' },
  toLabel: { de: 'Bis', en: 'To' },

  system: { de: 'System', en: 'System' },
  service: { de: 'Dienst', en: 'Service' },
  colUser: { de: 'Benutzer', en: 'User' },
  unknownUser: { de: 'Unbekannter Benutzer', en: 'Unknown user' },
  userDetails: { de: 'Benutzerdetails', en: 'User details' },
  email: { de: 'E-Mail', en: 'Email' },
  roles: { de: 'Rollen', en: 'Roles' },
  statusLabel: { de: 'Status', en: 'Status' },
  active: { de: 'Aktiv', en: 'Active' },
  disabled: { de: 'Deaktiviert', en: 'Disabled' },
  userNotFound: {
    de: 'Dieser Benutzer existiert nicht mehr im Verzeichnis (evtl. gelöscht).',
    en: 'This user is no longer in the directory (possibly deleted).',
  },
  detail: { de: 'Details', en: 'Detail' },
  actorId: { de: 'Akteur-ID', en: 'Actor ID' },
  entryId: { de: 'Eintrags-ID', en: 'Entry ID' },
  siteScope: { de: 'Standort', en: 'Site' },
  affectedSite: { de: 'Betroffener Standort', en: 'Affected site' },
  cloudScope: { de: 'Cloud', en: 'Cloud' },

  emptyFiltered: { de: 'Keine Einträge passen zu diesen Filtern', en: 'No entries match these filters' },
  loadMore: { de: 'Mehr laden', en: 'Load more' },
  loadedCount: { de: '{count} Einträge geladen', en: '{count} entries loaded' },
  entryTitle: { de: 'Protokolleintrag', en: 'Audit entry' },
  searchMode: { de: 'Suchen nach', en: 'Search by' },
  filterResult: { de: 'Ergebnis', en: 'Result' },
  exportCsv: { de: 'CSV exportieren', en: 'Export CSV' },
  exportHint: { de: 'Exportiert die geladenen Zeilen', en: 'Exports the loaded rows' },
  loadError: { de: 'Audit-Protokoll konnte nicht geladen werden', en: "Couldn't load the audit log" },
  emptyTitle: { de: 'Keine Einträge', en: 'No entries' },
  emptyMsg: {
    de: 'Keine Audit-Einträge für die aktuellen Filter.',
    en: 'No audit entries match the current filters.',
  },
} as const satisfies Namespace;
